// 404 (DESIGN_SPEC §11.1, §10.15): a full-page empty state on the atmosphere, with the 72-column
// moth in a small plate, the dotted rule, one line naming the path and one action.
//   <NotFoundPage />   route "*"
import { Link, useLocation } from "react-router-dom";
import moth72 from "@/assets/specimen/moth-72.json";
import { Arrow, Ascii, Empty, Kicker, Plate, Specimen, buttonClass } from "@/components/ui";

export function NotFoundPage() {
  const { pathname } = useLocation();
  return (
    <div className="page grid min-h-[calc(100svh-var(--nav-h)-160px)] place-items-center">
      <Empty
        figure={
          <>
            <Specimen label="An empty specimen plate" className="mb-3 w-72 max-w-full">
              <Plate sm>
                <Ascii art={moth72} maxPx={4.6} />
              </Plate>
            </Specimen>
            <Kicker as="div">Not found · 404</Kicker>
          </>
        }
        action={
          <div className="mt-2 grid justify-items-center gap-3">
            <Link className={buttonClass({ variant: "primary" })} to="/submit" viewTransition>
              Submit a sample <Arrow />
            </Link>
            <Link className={buttonClass({ variant: "ghost" })} to="/jobs" viewTransition>
              All analyses <Arrow />
            </Link>
          </div>
        }
      >
        Nothing is pinned at{" "}
        <span className="id whitespace-normal wrap-anywhere" translate="no">
          {pathname}
        </span>
        .
      </Empty>
    </div>
  );
}
